// Body load opacity
$(window).on("load",(function(){ 
  setTimeout(function(){     
	$("body").animate({opacity:1},900);  
    $("#marquee_wrapper svg").css('width', 'auto'); 
  }, 500);
}));

$(document).ready(function() {
  $(".announcement-barrow").prependTo(".header-row");
  $('.announcement_slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    vertical:false,
    fade: true,
    autoplay: true,
    speed: 1500
});
});


// Search open
$('.icon-search-link').on('click', function () {
    $('.search-header').slideToggle('fast');
   $('.search-header__input').focus();
});



// Sub navigation menu hover change image
$('.subnav-links li').on('mouseover', function(){
var navimg = $(this).attr('id');  
$('.nav_imgbox ').removeClass('active');      
$('#'+ navimg +'_div').addClass('active');      
});     

// Header add class on scroll
$(window).scroll(function(){
    if ($(this).scrollTop() > 100) {
       $('.header-row').addClass('dark_header');
    } else {
      $('.header-row').removeClass('dark_header');
    }
});

// Mobile menu click
$('.mo_menulink').on('click', function () {
  $('#SiteNav').slideToggle('fast');  
   $('.header-row').toggleClass('header_black');
    $(this).toggleClass('active');  
    $(this).text(function(i, v){
    return v === 'Menu' ? 'Close' : 'Menu'
  })
});


if($(window).width() < 767){
  // Mobile sub menu open
  $('.site-nav--has-dropdown > a').on('click', function () {
  /*
    $('.site-nav__dropdown').not(this).slideUp('fast');
    $(this).next('.site-nav__dropdown').slideToggle('fast');*/
  


   $('li').find('.site-nav__dropdown').stop().slideUp('fast');
	$(this).closest('li').find('.site-nav__dropdown').stop().slideToggle('fast');  	
  });
} 

